import { Injectable } from '@angular/core';

@Injectable()
export class BlobService {
    public base64toBlob(b64Data: string, contentType: string, sliceSize = 512): Blob { // slice is used to improve the performance. This would process the byteCharacters into small slices instead of all at once.
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

      const byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        return new Blob(byteArrays, { type: contentType });
    }

    public base64PdfToBlob(base64String: string): Blob {
        if (!base64String) {
            return;
        }

        // Sanitize the Base64 string
        let sanitizedBase64 = base64String.trim();
        sanitizedBase64 = sanitizedBase64.replace(/^["']|["']$/g, ''); // Remove surrounding quotes
        sanitizedBase64 = sanitizedBase64.replace(/\s/g, ''); // Remove line breaks and spaces

        // Validate Base64 content
        const base64Content = sanitizedBase64.split(',')[1] || sanitizedBase64; // Support prefixed or raw Base64
        const base64Regex = /^[A-Za-z0-9+/]+={0,2}$/;
        if (!base64Regex.test(base64Content)) {
            console.error('Invalid Base64 string:', base64Content);
            return;
        }

        const base64Prefix = 'data:application/pdf;base64,';
        const base64 = sanitizedBase64.startsWith(base64Prefix)
            ? sanitizedBase64
            : `${ base64Prefix }${ sanitizedBase64 }`;

        const contentType = base64.split(';')[0].split(':')[1];

        const byteCharacters = atob(base64Content);
        const byteNumbers = [];

        for (let i = 0; i < byteCharacters.length; i = i + 1) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array([...byteCharacters].map(char => char.charCodeAt(0)));
        return new Blob([byteArray], { type: contentType });
    }

    public getBlobObjectURL(blob: Blob): string {
        return window.URL.createObjectURL(blob);
    }
}
